export const config = {
  eraColors: {
    red: ["#760019", "#9F2C36", "#BF4147", "#E46B6B"],
    green: ["#02543B", "#53B439", "#73906D", "#56CD71"],
    blue: ["#182B44", "#208AC4", "#E0EBEE", "#048DC4"],
    gold: ["#764502", "#C4975A", "#FDEACD", "#CEB473"],
    greige: ["#898989", "#8D867A", "#CDCDCD", "#EEE9E0"],
  },
  share: {
    debug: false,
    // container: "#share-generator",
    assets: "/assets/images/",
    style: {
      font: "CommonGround_Regular",
      textHeightHack: 0.65,
      size: {
        default: {
          heading: 28,
          value: 120,
          unit: 37,
          legal: 12,
        },
        story: {
          heading: 48,
          value: 208,
          unit: 64,
          legal: 20,
        },
        post: {
          heading: 48,
          value: 208,
          unit: 64,
          legal: 20,
        },
      },
      spacing: {
        default: {
          heading: 1.4,
          value: 6,
          unit: 2,
          legal: 0.6,
        },
        story: {
          heading: 1.2,
          value: 5,
          unit: 1.6,
          legal: 0.6,
        },
        post: {
          heading: 1.2,
          value: 5,
          unit: 1.6,
          legal: 0.6,
        },
      },
    },
    colors: {
      background: "#000",
      foreground: "#f0f0f0",
      artist: "#d6d5cf",
      legal: "#f0f0f0",
      border: "#f0f0f04d",
      debug: "#555",
    },
    offsets: {
      default: {
        padding: 25,
        top: 25,
        left: 783,
        title: 63,
        action: 28,
        unit: {
          x: 20,
          y: 96,
        },
        icon: {
          x: 320,
          scale: 0.625,
        },
        keyline: {
          width: 350,
          margin: 23,
        },
        artwork: {
          top: 95,
          right: 67,
          bottom: 95,
          left: 47,
          padding: 32,
        },
      },
      story: {
        padding: 72,
        top: 207,
        left: 72,
        title: 160,
        action: 48,
        unit: {
          x: 20,
          y: 167,
        },
        icon: {
          x: 550,
          scale: 1,
        },
        keyline: {
          width: 600,
          margin: 40,
        },
      },
      post: {
        padding: 72,
        top: 72,
        left: 72,
        title: 96,
        action: 48,
        unit: {
          x: 20,
          y: 167,
        },
        icon: {
          x: 550,
          scale: 1,
        },
        keyline: {
          width: 600,
          margin: 40,
        },
      },
    },
    social: {
      endpoint:
        "https://vajhmgiaazofuifnydy7xea3am0kqama.lambda-url.us-east-1.on.aws/",
      url: "https://artratemonitor.ca/",
      text: "Discover the #ArtRateMonitor. This unique experience tracks how your heart reacts to our art. Now closed to the public. Thanks to all who participated.",
    },
  },
};

export const expectedUrlParams = [
  {
    name: "VN",
    description: "Visitor name",
    type: "string",
  },
  {
    name: "VID",
    description: "Visitor unique identifier",
    type: "string",
  },
  {
    name: "VP",
    description: "Visitor persona",
    type: "integer",
  },
  {
    name: "VH",
    description: "Visitor highest BPM value",
    type: "integer",
  },
  {
    name: "VHAID",
    description:
      "Artwork identifier where the visitor experienced their highest BPM",
    type: "string",
  },
  {
    name: "VL",
    description: "Visitor lowest BPM value",
    type: "integer",
  },
  {
    name: "VLAID",
    description:
      "Artwork identifier where the visitor experienced their lowest BPM",
    type: "string",
  },
  {
    name: "VT",
    description: "Visitor highest time spent value (in minutes)",
    type: "integer",
  },
  {
    name: "VTAID",
    description:
      "Artwork identifier where the visitor experienced their longest dwell time",
    type: "string",
  },
  {
    name: "VC",
    description: "Visitor era (colour palette)",
    type: "integer",
  },
  {
    name: "VE",
    description: "Recommended exhibit",
    type: "integer",
  },
];

export const defaultAssets = [
  {
    url: "/assets/images/logo-ago.svg",
    type: "image",
  },
  {
    url: "/assets/images/icon-close.svg",
    type: "image",
  },
  {
    url: "/assets/videos/intro.mp4",
    type: "video",
  },
];

export const experienceAssets = [
  {
    url: "/assets/images/icon-heart.svg",
    type: "image",
  },
  {
    url: "/assets/images/icon-drop.svg",
    type: "image",
  },
  {
    url: "/assets/images/icon-download.svg",
    type: "image",
  },
];
